// Nomes das realm roles cadastradas no Keycloak (realm "licinet").
// Precisam bater exatamente com os nomes das roles criadas lá.
export const ROLES = {
  ADMIN: "admin",
  DEV: "dev",
  VISUALIZADOR: "visualizador",
  USER: "user",
};
